import { commafy } from "@lib/index";
import gate from "gate";
import React from "react";
import { useMutation, useQueryClient } from "react-query";

import Spinner from "../Spinner";

const Card = ({ item }: any) => {
  const query = useQueryClient();

  const { mutate, isLoading } = useMutation(gate.deleteOrder, {
    onSuccess: () => {
      query.invalidateQueries("order-list");
    },
  });

  return (
    <li
      className="grid-template-columns-max mb-3 grid grid-flow-col gap-x-[10px]"
      key={item?.id}
    >
      <img
        loading="lazy"
        className="h-[49px] w-[76px] rounded md:h-[73px] md:w-[112px]"
        src={item?.image}
        alt="تصویر دوره"
      />
      <div className="relative flex w-full flex-col justify-between">
        <div className="flex w-full justify-between">
          <span className="pl-5 text-xs md:text-base"> {item?.title}</span>
          {isLoading ? (
            <Spinner fill="red" />
          ) : (
            <span
              onClick={() => mutate(item?.id)}
              className="absolute top-0 left-2 -rotate-45 transform cursor-pointer text-xl text-[#F46A6A]"
            >
              +
            </span>
          )}
        </div>
        <div className="flex gap-x-[20px]">
          <span className="text-[11px] text-[#747474] md:text-[15px]">
            {item?.discount ? commafy(item?.discount) : commafy(item?.price)}{" "}
            تومان
          </span>
          {!!item?.discount && (
            <span className="text-[9px] text-[#999696] line-through md:text-sm">
              {commafy(item?.price)} تومان
            </span>
          )}
        </div>
      </div>
    </li>
  );
};

export default Card;
